// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"573":"29580fee","863":"e8cf43da"}[chunkId] + ".chunk.css";
};